export const WORKSPACES = {
  PUBLIC: 'public',
};

export const WORKSPACE_DEFAULTS = {
  [WORKSPACES.PUBLIC]: '/public/home',
};

export const FEATURE_FLAG_SECONDARIES = false;
export const FEATURE_FLAG_PRODUCT_TAGS = false;
export const FEATURE_FLAG_WATCHLIST = true;

export const PUBLIC_ROUTES = {
  ANALYZER: '/public/analyzer',
  FIND_STOCKS: '/public/find-stocks',
  SCREENER: '/public/screener',
  RESEARCH: '/public/research/:symbol',
  WATCHLIST: '/public/watchlist',
  NEWS: '/public/news',
  PORTFOLIO: '/public/portfolio',
  PORTFOLIO_HOLDINGS: '/public/portfolio/holdings',
  PORTFOLIO_PERFORMANCE: '/public/portfolio/performance',
  PORTFOLIO_NEWS: '/public/portfolio/news',
  PORTFOLIO_ANALYTICS: '/public/portfolio/analytics',
  PORTFOLIO_ALERTS: '/public/portfolio/alerts',
  PORTFOLIO_ADD: '/public/portfolio/add-holding',
  PORTFOLIO_STOCK: '/public/portfolio/stock/:symbol',
  PORTFOLIO_BROKER: '/public/portfolio/broker',
};


export const LEGACY_REDIRECT_MAP = {
  '/market/analyzer': '/public/analyzer',
  '/market/find-stocks': '/public/find-stocks',
  '/market/screener': '/public/screener',
  '/market/watchlist': '/public/watchlist',
  '/market/news': '/public/news',
  '/portfolio/dashboard': '/public/portfolio',
  '/portfolio/add-holding': '/public/portfolio/add-holding',
  '/portfolio/broker': '/public/portfolio/broker',
};

export const LEGACY_PREFIX_MAP = [
  { prefix: '/market/research/', replace: '/public/research/' },
  { prefix: '/portfolio/stock/', replace: '/public/portfolio/stock/' },
];
